"use client"

import * as React from "react"
import { MotionConfig } from "motion/react"

type MotionProviderProps = React.ComponentProps<typeof MotionConfig>

/**
 * Establishes the Quibas accessibility policy for a motion-enabled surface.
 * Transform and layout motion follows the user's OS preference by default.
 */
function MotionProvider({
  children,
  reducedMotion = "user",
  ...props
}: MotionProviderProps) {
  return (
    <MotionConfig {...props} reducedMotion={reducedMotion}>
      {children}
    </MotionConfig>
  )
}

export { MotionProvider }
export type { MotionProviderProps }
